"use client";
import Image from "next/image";
import React from "react";

export function Picture(props) {
  return (
    <div
      style={{
        position: "relative",
        height: props.height ? props.height : "auto",
        width: props.width ? props.width : "auto",
        cursor: `${props.onClick ? "pointer" : ""}`,
      }}
      onClick={props.onClick ? props.onClick : null}
    >
      <Image
        src={
          props.path === "null/null" || props.path === "undefined/undefined"
            ? "/img/placeholder.svg"
            : props.path
        }
        priority={props.priority ? props.priority : "false"}
        fill
        sizes={"auto"}
        style={{ objectFit: "contain" }}
        alt={props.alt}
        onError={(e) => {
          console.error(e);
          e.target.srcset = "/img/placeholder.svg";
        }}
      />
    </div>
  );
}
